<template>
  <v-container
    fluid
  >
    <v-row dense no-gutters v-if="$store.state.brand != 'cldy'">
      <v-app-bar
        app
        dense
      >
        <a v-if="$store.state.brand === 'qoxy'" href="https://manage.qoxy.com">
          <img src="/qoxylogo.png">
        </a>
        <v-spacer></v-spacer>
        <a
          class="header-btn"
          :class="{ 'header-btn-disabled': expressNavigationLocked }"
          :aria-disabled="expressNavigationLocked ? 'true' : 'false'"
          @click="gotoLogin()"
        >LOGIN</a>
        <span>|</span>
        <a
          class="header-btn"
          :class="{ 'header-btn-disabled': expressNavigationLocked }"
          :aria-disabled="expressNavigationLocked ? 'true' : 'false'"
          @click="gotoLogin()"
        >REGISTER</a>
        <v-badge
          color="green"
          :content="$store.state.shoppingCart.total_count + ''"
          overlap
          offset-x="20"
          offset-y="20"
        >
          <v-btn
            icon
            large
            :disabled="expressNavigationLocked"
            @click="goToCart()"
          >
            <v-avatar
              size="32px"
              item
            >
              <v-icon>mdi-cart-outline</v-icon>
            </v-avatar>
          </v-btn>
        </v-badge>
      </v-app-bar>
    </v-row>
    <CldyHeader
      v-if="$store.state.brand == 'cldy'"
      :navigation-locked="expressNavigationLocked"
    ></CldyHeader>
    <v-row
    >
      <v-col cols="1">
      </v-col>
      <v-col cols="10">
        <v-card
          outlined
        >
          <v-card-title>
            Pending Renewal:
            <v-spacer></v-spacer>
            <span v-if="isSgUser" class="subtitle-2">
              Singapore Dollars (SGD) (9% GST Inclusive)
            </span>
          </v-card-title>
          <v-card-text>
            <v-row class="cart">
              <v-col cols="12">
              </v-col>
              <v-col cols="12">
                <v-row align="center" justify="center"
                       v-for="(item, index) in items" :key="item.id">
                  <v-col cols="12" lg="6" class="text-left">
                    <b>{{ item.service_identity }}</b> Expiry: {{ item.expiry_date }}
                  </v-col>
                  <v-col cols="12" lg="2" class="text-center">
                    <v-select
                      :items="item.product_prices"
                      v-model="item.default_term"
                      item-text="term_name"
                      solo
                      dense
                      :disabled="loading"
                      @change="setSelectedItem(index)"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="8" lg="2" class="text-center">
                    ${{ item.price }}
                  </v-col>
                  <v-col cols="4" lg="2" class="text-center">
                    <v-btn color="error" :loading="loadings[index]"
                           :disabled="loading"
                           @click="deleteItem(index)">
                      <v-icon
                        small
                      >
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" v-for="addon in item.addons" :key="addon.id">
                    <v-row>
                      <v-col cols="8" lg="6" class="text-left addon-text">
                        <b>Addon: {{ addon.service_identity }}</b>
                      </v-col>
                      <v-col cols="4" lg="2" class="text-center">
                        <v-select
                          :items="addon.product_prices"
                          :value="item.default_term"
                          item-text="term_name"
                          solo
                          dense
                          readonly
                          hide-details
                        ></v-select>
                      </v-col>
                      <v-col cols="8" lg="2" class="text-center">
                        ${{ addon.price }}
                      </v-col>
                      <v-col cols="4" lg="2" class="text-center">
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row justify="center">
                  <v-col lg="8" cols="2" class="text-center">
                  </v-col>
                  <v-col lg="2" cols="2" class="text-center">
                  </v-col>
                  <v-col lg="2" cols="8" class="text-center">
                    <h5 v-if="totalTax > 0">
                      Inclusive of GST @9%: ${{ totalTax }}
                    </h5>
                    <h3>Total: ${{ total }}</h3>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="payment" v-if="tokenValid">
              <v-col cols="12" lg="6">
                <stripe-payment
                  v-if="paymentMethod == 3"
                  :amount="shoppingCart.total_amount"
                  :card.sync="creditCard"
                  :invalid.sync="creditCardInvalid"
                ></stripe-payment>
                <paypal-payment
                  v-if="paymentMethod == 4"
                  :amount="shoppingCart.total_amount"
                  :orderid="paypalOrderId"
                  @interface="getChildInterface"
                  :saveasdefaultcard="false"
                  :card.sync="creditCard"
                  :invalid.sync="creditCardInvalid"
                ></paypal-payment>
                <airwallex-payment
                  :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                      show-method-selector
                  @apple-pay-selected="selectAirwallexApplePay"
                  v-if="[7, 8].includes(paymentMethod)"
                  :amount="shoppingCart.total_amount"
                  :invalid.sync="creditCardInvalid"
                  :disabled="loading"
                  @interface="getAirwallexInterface"
                ></airwallex-payment>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              dense
              v-if="tokenValid && $store.state.brand === 'cldy'"
            >
              <v-col cols="12">
                <div class="d-flex justify-end">
                  <v-checkbox
                    v-model="tosAccepted"
                    hide-details
                    class="mb-2"
                    :disabled="loading || !!tosAuditPromise"
                    @change="recordTosDecision"
                  >
                    <template v-slot:label>
                      <div>
                        I have read, understood, and accept the
                        <a
                          href="https://www.cldy.com/sg/terms-of-service/"
                          target="_blank"
                          rel="noopener"
                          @click.stop
                        >Terms of Service</a>.
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="tokenValid">
              <v-col cols="12" class="text-right">
                <v-btn
                  v-if="paymentMethod == 4"
                  color="primary" class="pay-btn"
                       :loading="loading"
                       :disabled="creditCardInvalid
                       || ($store.state.brand === 'cldy' && !tosAccepted)"
                       @click="submit">Checkout (Visa/Master)</v-btn>
                <v-btn
                  v-else-if="[7, 8].includes(paymentMethod)"
                  color="primary" class="pay-btn"
                       :loading="loading"
                       :disabled="creditCardInvalid
                         || ($store.state.brand === 'cldy' && !tosAccepted)"
                       @click="submit">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Checkout (Visa/Master)' }}
                </v-btn>
                <v-btn
                  v-else
                  color="primary" class="pay-btn"
                       :loading="loading"
                       :disabled="creditCardInvalid
                       || ($store.state.brand === 'cldy' && !tosAccepted)"
                       @click="submit">Checkout</v-btn>
                <v-btn
                  color="primary" class="pay-btn"
                  :loading="loading"
                  :disabled="$store.state.brand === 'cldy' && !tosAccepted"
                  v-if="paynowEnabled"
                  @click="submitPaynow">Checkout (Paynow)</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer v-if="$store.state.brand != 'cldy'"
      dark
      padless
      :app="true"
      :fixed="true"
    >
      <v-card
        flat
        tile
        class="indigo lighten-1 white--text text-center"
        width="100%"
      >
        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>Powered By GoCloudEasy Pte Ltd</strong>
        </v-card-text>
      </v-card>
    </v-footer>
    <CldyFooter v-if="$store.state.brand == 'cldy'"></CldyFooter>
  </v-container>
</template>

<script>
import { getApiBaseUrl } from '@/config/api';
import { mapState } from 'vuex';
import { create, all } from 'mathjs';
import airwallexWallet from '../../mixins/airwallex-wallet';
import { StripePayment, PaypalPayment, AirwallexPayment } from '../components/payment_modules';
import {
  isAirwallexPaymentPending,
} from '../../plugins/airwallex-payment';
import { recordTosDecision as auditTosDecision } from '../../plugins/tos-audit';
import CldyHeader from './CldyHeader.vue';
import CldyFooter from './CldyFooter.vue';
import airwallexCartRecovery from '../../mixins/airwallex-cart-recovery';

export default {
  name: 'ShoppingCart',
  mixins: [airwallexWallet, airwallexCartRecovery],
  components: {
    StripePayment,
    PaypalPayment,
    AirwallexPayment,
    CldyHeader,
    CldyFooter,
  },
  data() {
    return {
      paymentMethod: '',
      paynowEnabled: false,
      tokenValid: false,
      valid: false,
      loading: false,
      unpaidLoading: false,
      loadings: [],
      items: [],
      paypalOrderId: '',
      saveAsDefaultCard: false,
      creditCardInvalid: true,
      creditCard: null,
      total: 0,
      totalTax: 0,
      isSgUser: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      firstInvoice: false,
      tosAccepted: false,
      tosAuditPromise: null,
      tosAuditSucceeded: true,
    };
  },
  computed: {
    expressNavigationLocked() {
      return this.loading
        || this.airwallexCartCompletionInProgress;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    localComputed() {
    },
    // mix this into the outer object with the object spread operator
    ...mapState({
      shoppingCart: 'shoppingCart',
    }),
  },
  created() {
    this.$api.get('partner/payment-methods', {
      params: { token: this.$route.params.token },
    })
      .then((response) => {
        this.paymentMethods = this.filterWalletPaymentMethods(response.data);
        this.paynowEnabled = response.data.some((method) => Number(method.id) === 6);
      })
      .catch(() => {
        this.paynowEnabled = false;
      });

    this.refreshAirwallexCartRecovery()
      .then((response) => {
        const recovery = this.airwallexPaymentRecovery;

        if (recovery && recovery.action === 'completed') {
          this.acknowledgeAirwallexCartRecovery(recovery).catch(() => null);
        }

        this.applyAirwallexCartRecovery(null);
        return response;
      })
      .catch(() => {
        this.applyAirwallexCartRecovery(null);
      });

    this.$api.get(`has-no-invoice?token=${this.$route.params.token}`)
      .then((response) => {
        this.$set(this, 'firstInvoice', response.data.has_no_invoice);
      });

    this.$api.get(`partner/default-payment-method?token=${this.$route.params.token}`).then((response) => {
      const paymentMethod = response.data;
      this.$set(this, 'paymentMethod', paymentMethod);
      if (paymentMethod === 4) {
        this.creditCardInvalid = false;
      }
    });
  },
  methods: {
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getAirwallexInterface(childInterface) {
      this.$options.airwallexInterface = childInterface;
    },
    cloneCheckoutItems(items) {
      return JSON.parse(JSON.stringify(items));
    },
    navigateToPaynowInvoice(paymentResponse) {
      const response = paymentResponse
        && typeof paymentResponse === 'object'
        && !Array.isArray(paymentResponse)
        ? paymentResponse
        : {};
      const invoiceId = Number(response.invoice_id);
      const viewToken = typeof response.view_token === 'string'
        ? response.view_token.trim()
        : '';

      if (!Number.isInteger(invoiceId) || invoiceId <= 0 || !viewToken) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The PayNow payment response is incomplete. Please retry again.',
        });
        return Promise.resolve(false);
      }

      const invoiceRoute = {
        name: 'Retail.ExpressInvoicePayment',
        params: {
          brand: this.$store.state.brand,
          id: response.invoice_id,
        },
        query: {
          token: viewToken,
          payment: 6,
        },
      };

      return this.$router.replace(invoiceRoute).catch((error) => {
        if (this.isNavigationDuplicated(error)) {
          return true;
        }

        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The invoice page could not be opened. Redirecting now.',
        });
        const resolvedRoute = this.$router.resolve(invoiceRoute);

        if (resolvedRoute && resolvedRoute.href) {
          window.location.assign(resolvedRoute.href);
        }

        return false;
      });
    },
    airwallexCartRecoveryScope() {
      return 'express';
    },
    fetchAirwallexCartRecovery() {
      return this.$api.post(`pending-renewal/${this.$route.params.token}`);
    },
    syncAirwallexCartData(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        return;
      }

      this.tokenValid = true;
      this.isSgUser = String(cart.country || '').toUpperCase() === 'SG';

      const localItems = this.cloneCheckoutItems(cart.items)
        .filter((item) => (
          Array.isArray(item.product_prices)
          && item.product_prices.length > 0
        ));

      for (let itemIndex = 0; itemIndex < localItems.length; itemIndex += 1) {
        const item = localItems[itemIndex];

        item.product_prices.forEach((price, index) => {
          if (index === 0) {
            item.default_term = price.value;
            item.price = price.product_price;
          }

          if (parseInt(price.term_month, 10) === item.service_month_term) {
            item.default_term = price.value;
            item.price = price.product_price;
          }
        });
      }

      this.$set(this, 'items', localItems);
      this.setSelectedItem();
    },
    acknowledgeAirwallexCartRecovery(recovery) {
      if (!recovery || !recovery.attempt_id) {
        return Promise.resolve();
      }

      return this.$api.post(
        `express-checkout/${this.$route.params.token}/recovery/acknowledge`,
        {
          attempt_id: recovery.attempt_id,
        },
        this.airwallexCartRecoveryAcknowledgeConfig(),
      );
    },
    onAirwallexCartRecoveryApplied() {
    },
    onAirwallexCartRecoveryCompleted(invoice) {
      const invoiceUrl = `${getApiBaseUrl()}/v1/tax-invoice/${invoice.invoice_no}/view?view_token=${invoice.view_token}&system_currency=${window.systemCurrency}`;
      const redirectToInvoice = () => {
        window.location.href = invoiceUrl;
      };

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your payment is submitted successfully.',
      });

      if (!this.firstInvoice) {
        redirectToInvoice();
        return Promise.resolve();
      }

      setTimeout(redirectToInvoice, 500);
      return this.$api.get(
        `tax-invoice/${invoice.invoice_id}/detail?express_token=${invoice.view_token}`,
      ).then((response) => {
        const invoiceItems = response.data.invoiceItems.map((invoiceItem) => ({
          item_id: invoiceItem.id,
          item_name: `${response.data.invoiceDatetime} ${invoiceItem.invoiceLineDescription}`,
          price: invoiceItem.subtotal,
          discount: invoiceItem.discount,
          tax: invoiceItem.tax,
          quantity: 1,
        }));
        const gtagObj = {
          currency: window.systemCurrency.toUpperCase(),
          value: response.data.total,
          discount: response.data.discount,
          tax: response.data.tax,
          items: invoiceItems,
        };

        if (this.$store.state.brand === 'cldy'
          && typeof window.gtag === 'function'
        ) {
          window.gtag('event', 'purchase', gtagObj);
        }
      }).catch(() => null);
    },
    deleteItem(index) {
      if (this.loading) {
        return;
      }

      this.items.splice(index, 1);
      this.setSelectedItem();
    },
    recordTosDecision(checked) {
      this.tosAuditSucceeded = false;
      const auditRequest = auditTosDecision({
        api: this.$api,
        store: this.$store,
        checked,
        context: 'express_checkout',
        token: this.$route.params.token,
      }).then(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditSucceeded = true;
        }
        return true;
      }).catch(() => false).finally(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditPromise = null;
        }
      });
      this.tosAuditPromise = auditRequest;
    },
    async waitForTosAudit() {
      let pendingTosAudit = this.tosAuditPromise;
      while (pendingTosAudit) {
        // eslint-disable-next-line no-await-in-loop
        await pendingTosAudit;
        pendingTosAudit = this.tosAuditPromise;
      }
      return this.tosAuditSucceeded
        && !(this.$store.state.brand === 'cldy' && !this.tosAccepted);
    },
    async submit() {
      if (this.loading) {
        return;
      }

      this.applyAirwallexCartRecovery(null);

      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.loading = true;
      const checkoutItems = this.cloneCheckoutItems(this.items);

      if (!(await this.waitForTosAudit())) {
        this.loading = false;
        return;
      }

      if (this.paymentMethod === 3) {
        if (this.creditCardInvalid) {
          this.loading = false;
          return;
        }
        this.$api.post(`express-checkout/${this.$route.params.token}`, {
          items: checkoutItems,
          payment_type_id: this.paymentMethod,
        })
          .then((response) => {
            const stripePaymentObj = {
              payment_method: {
                card: this.creditCard,
              },
            };

            window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
              .then(async (result) => {
                if (result.error) {
                  await this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: result.error,
                  });
                }

                if (result.paymentIntent.status === 'requires_capture') {
                  await this.$api.post(`express-checkout/${this.$route.params.token}`, {
                    payment_type_id: this.paymentMethod,
                    confirm: 1,
                    id: result.paymentIntent.id,
                  })
                    .then((subresponse) => {
                      if (this.firstInvoice) {
                        this.$api.get(`tax-invoice/${subresponse.data.invoice_id}/detail?express_token=${subresponse.data.view_token}`)
                          .then((subSubResponse) => {
                            const invoiceItems = [];

                            subSubResponse.data.invoiceItems.forEach((invoiceItem) => {
                              invoiceItems.push({
                                item_id: invoiceItem.id,
                                item_name: `${subSubResponse.data.invoiceDatetime} ${invoiceItem.invoiceLineDescription}`,
                                price: invoiceItem.subtotal,
                                discount: invoiceItem.discount,
                                tax: invoiceItem.tax,
                                quantity: 1,
                              });
                            });

                            const gtagObj = {
                              currency: window.systemCurrency.toUpperCase(),
                              value: subSubResponse.data.total,
                              discount: subSubResponse.data.discount,
                              tax: subSubResponse.data.tax,
                              items: invoiceItems,
                            };

                            if (this.$store.state.brand === 'cldy') {
                              window.gtag('event', 'purchase', gtagObj);
                            }

                            const successMessage = 'Your payment is submitted successfully.';

                            this.$store.dispatch('addAlert', {
                              id: Date.now(),
                              type: 'success',
                              message: successMessage,
                            });

                            setTimeout(() => {
                              window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
                            }, 500);
                          });
                      } else {
                        const successMessage = 'Your payment is submitted successfully.';

                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });

                        window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
                      }
                    });
                }
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 4) {
        this.$api.post(`express-checkout/${this.$route.params.token}`, {
          items: checkoutItems,
          payment_type_id: this.paymentMethod,
        })
          .then((response) => {
            this.$set(this, 'paypalOrderId', response.data.order_id);
            this.$nextTick(() => {
              this.$options.childInterface.checkout()
                .then((payload) => {
                  if (payload.liabilityShift !== 'NO'
                    && payload.authenticationStatus
                    && payload.authenticationStatus !== 'YES') {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: '3D Secure Authentication fails. Please retry again.',
                    });
                    this.loading = false;
                    return;
                  }

                  if (payload.liabilityShift === 'NO'
                    && payload.liabilityShifted === false
                    && payload.authenticationStatus
                    && payload.authenticationStatus === 'NO') {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: 'You have exited 3D Secure Authentication. Please retry again.',
                    });
                    this.loading = false;
                    return;
                  }

                  this.$api.post(`express-checkout/${this.$route.params.token}`, {
                    payment_type_id: this.paymentMethod,
                    confirm: 1,
                    id: payload.orderId,
                  })
                    .then((subresponse) => {
                      if (this.firstInvoice) {
                        this.$api.get(`tax-invoice/${subresponse.data.invoice_id}/detail?express_token=${subresponse.data.view_token}`)
                          .then((subSubResponse) => {
                            const invoiceItems = [];

                            subSubResponse.data.invoiceItems.forEach((invoiceItem) => {
                              invoiceItems.push({
                                item_id: invoiceItem.id,
                                item_name: `${subSubResponse.data.invoiceDatetime} ${invoiceItem.invoiceLineDescription}`,
                                price: invoiceItem.subtotal,
                                discount: invoiceItem.discount,
                                tax: invoiceItem.tax,
                                quantity: 1,
                              });
                            });

                            const gtagObj = {
                              currency: window.systemCurrency.toUpperCase(),
                              value: subSubResponse.data.total,
                              discount: subSubResponse.data.discount,
                              tax: subSubResponse.data.tax,
                              items: invoiceItems,
                            };

                            if (this.$store.state.brand === 'cldy') {
                              window.gtag('event', 'purchase', gtagObj);
                            }

                            const successMessage = 'Your payment is submitted successfully.';

                            this.$store.dispatch('addAlert', {
                              id: Date.now(),
                              type: 'success',
                              message: successMessage,
                            });

                            setTimeout(() => {
                              window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
                            }, 500);
                          });
                      } else {
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: 'Your payment is submitted successfully.',
                        });
                        window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
                      }
                    });
                })
                .catch((error) => {
                  if (error.message.indexOf('semantically incorrect') > 0
                    || error.message.indexOf('not well-formed') > 0) {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                    });
                  } else {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: `An error occurred ${error.message}. Please retry again.`,
                    });
                  }
                  this.loading = false;
                });
            });
          });
      }

      if (this.paymentMethod === 6) {
        this.$api.post(`express-checkout/${this.$route.params.token}`, {
          items: checkoutItems,
          payment_type_id: this.paymentMethod,
        })
          .then((response) => this.navigateToPaynowInvoice(response.data))
          .finally(() => {
            this.loading = false;
          });
      }

      if ([7, 8].includes(this.paymentMethod)) {
        if (this.creditCardInvalid) {
          this.loading = false;
          return;
        }

        const confirmPayment = (paymentIntentId) => this.$api
          .post(
            `express-checkout/${this.$route.params.token}`,
            {
              payment_type_id: Number(this.paymentMethod),
              confirm: 1,
              id: paymentIntentId,
            },
          )
          .then((response) => {
            this.applyAirwallexCartRecoveryFromResponse(response);
            return response;
          });
        const finishPayment = async (response) => {
          if (!response) {
            return;
          }

          const responseRecovery = this
            .applyAirwallexCartRecoveryFromResponse(response);

          if (responseRecovery && responseRecovery.action === 'completed') {
            await this.completeAirwallexCartRecovery(responseRecovery);
            return;
          }

          if (responseRecovery && responseRecovery.action === 'blocked') {
            throw new Error(
              'The credit card payment result could not be verified. '
                + 'You may retry with another card; this attempt was recorded '
                + `for manual review.${
                  this.airwallexCartSupportReferenceSuffix(responseRecovery)
                }`,
            );
          }

          if (isAirwallexPaymentPending(response)) {
            const paymentIntentId = this
              .resolveAirwallexCartPaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card payment details are missing.');
            }

            if (!this.hasAirwallexCartRecoveryPayload(response)) {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: 'new',
                payment_card_id: null,
              });
            }

            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'info',
              message: 'Your card authorization is still processing. You may '
                + 'retry with another card; overlapping payments are recorded '
                + 'for manual review.',
            });
            this.applyAirwallexCartRecovery(null);
            return;
          }

          if (response.data && response.data.invoice_id) {
            await this.completeAirwallexCartInvoice(response.data);
            return;
          }

          if (!responseRecovery || !['check_status', 'finalize'].includes(
            responseRecovery.action,
          )) {
            throw new Error(
              'The payment result could not be verified. You may retry with '
                + 'another card; this attempt was recorded for manual review.',
            );
          }
        };
        const handlePaymentError = (error) => this.handleAirwallexCartError(error);
        const completePayment = (paymentPromise) => paymentPromise
          .then(finishPayment)
          .catch(handlePaymentError)
          .finally(() => {
            this.loading = false;
          });

        this.rememberAirwallexCartRecovery({
          action: 'authorize',
          recoverable: true,
          payment_intent_id: null,
          mode: 'new',
          payment_card_id: null,
          amount: Number(this.total).toFixed(2),
        });

        const authorizePayment = () => this.$api.post(
          `express-checkout/${this.$route.params.token}`,
          {
            items: checkoutItems,
            payment_type_id: Number(this.paymentMethod),
            start_fresh_cart_payment: 1,
          },
        ).then((response) => {
          const responseRecovery = this
            .applyAirwallexCartRecoveryFromResponse(response);

          if (responseRecovery
            && ['completed', 'blocked'].includes(responseRecovery.action)
          ) {
            return response;
          }

          const paymentIntentId = this
            .resolveAirwallexCartPaymentIntentId(response);

          if (!paymentIntentId) {
            throw new Error('The credit card payment details are missing.');
          }

          if (isAirwallexPaymentPending(response)
            || (responseRecovery
              && ['check_status', 'finalize'].includes(responseRecovery.action))
          ) {
            if (!this.hasAirwallexCartRecoveryPayload(response)) {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: 'new',
                payment_card_id: null,
              });
            }

            return this.pollAirwallexCartPayment(
              () => confirmPayment(paymentIntentId),
              isAirwallexPaymentPending(response) ? response : null,
            );
          }

          if (!response.data.client_secret || !this.$options.airwallexInterface) {
            throw new Error('The credit card payment form is not ready.');
          }

          return this.$options.airwallexInterface.confirmIntent(
            paymentIntentId,
            response.data.client_secret,
          ).then(() => {
            this.rememberAirwallexCartRecovery({
              action: 'check_status',
              recoverable: true,
              payment_intent_id: paymentIntentId,
              mode: 'new',
              payment_card_id: null,
            });
            return this.pollAirwallexCartPayment(
              () => confirmPayment(paymentIntentId),
            );
          });
        });
        await completePayment(authorizePayment());
      }
    },
    async submitPaynow() {
      if (!this.paynowEnabled || this.loading) {
        return;
      }
      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.loading = true;
      const checkoutItems = this.cloneCheckoutItems(this.items);

      if (!(await this.waitForTosAudit())) {
        this.loading = false;
        return;
      }

      this.$api.post(`express-checkout/${this.$route.params.token}`, {
        items: checkoutItems,
        payment_type_id: 6,
      })
        .then((response) => this.navigateToPaynowInvoice(response.data))
        .finally(() => {
          this.loading = false;
        });
    },
    gotoLogin() {
      if (this.expressNavigationLocked) {
        return;
      }

      const { brand } = this.$store.state;
      this.navigateFromExpressCheckout({
        name: 'Retail.Login',
        params: { brand },
      });
    },
    isNavigationDuplicated(error) {
      return !!error && error.name === 'NavigationDuplicated';
    },
    navigateFromExpressCheckout(route) {
      return this.$router.push(route).catch((error) => {
        if (this.isNavigationDuplicated(error)) {
          return null;
        }

        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'The requested page could not be opened. Please try again.',
        });
        return null;
      });
    },
    goToCart() {
      if (this.expressNavigationLocked) {
        return;
      }

      const { brand } = this.$store.state;
      if (this.$store.state.user.role) {
        this.navigateFromExpressCheckout({
          name: 'Retail.ShoppingCart',
          params: { brand },
        });
      } else {
        this.navigateFromExpressCheckout({
          name: 'Retail.GuestShoppingCart',
          params: { brand },
        });
      }
    },
    gotoHome() {
      if (this.expressNavigationLocked) {
        return;
      }

      const { brand } = this.$store.state;
      this.navigateFromExpressCheckout({
        name: 'Retail.Guest',
        params: { brand },
      });
    },
    setSelectedItem() {
      const config = {};
      const math = create(all, config);
      this.total = 0;
      this.totalTax = 0;

      this.items.forEach((item, index) => {
        item.product_prices.forEach((price) => {
          if (price.value === item.default_term) {
            this.items[index].price = price.product_price;
            this.total = math.format(math.add(this.total, price.product_price), {
              precision: 14,
            });
            if (price.tax > 0) {
              this.totalTax = math.format(math.add(this.totalTax, price.tax), {
                precision: 14,
              });
            }
          }
        });

        const addons = Array.isArray(item.addons) ? item.addons : [];
        addons.forEach((addon, addonIndex) => {
          const addonDefaultTerm = item.default_term;

          addon.product_prices.forEach((price) => {
            if (price.value === addonDefaultTerm) {
              this.items[index].addons[addonIndex].price = price.product_price;
              this.total = math.format(math.add(this.total, price.product_price), {
                precision: 14,
              });
              if (price.tax > 0) {
                this.totalTax = math.format(math.add(this.totalTax, price.tax), {
                  precision: 14,
                });
              }
            }
          });
        });
      });
    },
  },
};
</script>

<style scoped>
.cart {
  max-height: 640px;
  overflow-y: scroll;
}

.pay-btn {
  margin-left: 10px;
}

.header-btn-disabled {
  opacity: .5;
  pointer-events: none;
}

.addon-text {
  padding-left: 20px;
  font-size: 12px;
}
</style>
